import React from 'react';

interface CrossProps {
  className: string;
  onClick?: () => void;
}

export const Cross = ({ className, onClick }: CrossProps) => {
  return (
    <svg
      aria-hidden="true"
      className={className}
      width="12px"
      height="12px"
      viewBox="0 0 16 16"
      version="1.1"
      onClick={onClick}
    >
      <g transform="translate(-104.000000, -12.000000)">
        <g transform="translate(92.000000, 0.000000)">
          <g transform="translate(13.000000, 13.000000)">
            <path d="M0,0 L14,14"></path>
            <path d="M14,0 L0,14"></path>
          </g>
        </g>
      </g>
    </svg>
  );
};
